import FillBlanks from "../../components/ClassOne/EnvironmentScience/CleanSafety/FillBlanks";
import MultipleChoice from "../../components/ClassOne/EnvironmentScience/CleanSafety/MultipleChoice";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/CleanSafety/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/clean-safety-healthy/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/clean-safety-healthy/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/clean-safety-healthy/multiple-choice-question", title: "Multiple Choice Question", component: MultipleChoice }
]

export default topics;